/**
 * Formats a string as an Australian Business Number (ABN).
 * Format: XX XXX XXX XXX (e.g., 12 345 678 901)
 *
 * @param {string|number} val - The input value to format
 * @returns {string} - The formatted ABN string
 */
export function formatABN(val) {
  if (!val) return "";
  // Strip all non-digit characters
  const clean = val.toString().replace(/\D/g, "");
  // Keep up to 11 digits
  const truncated = clean.slice(0, 11);
  // Format as XX XXX XXX XXX
  const parts = [];
  if (truncated.length > 0) parts.push(truncated.slice(0, 2));
  if (truncated.length > 2) parts.push(truncated.slice(2, 5));
  if (truncated.length > 5) parts.push(truncated.slice(5, 8));
  if (truncated.length > 8) parts.push(truncated.slice(8, 11));
  return parts.join(" ");
}
